import { render, staticRenderFns } from "./HomeSubmissionItem.vue?vue&type=template&id=370ae504&"
import script from "./HomeSubmissionItem.vue?vue&type=script&lang=js&"
export * from "./HomeSubmissionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports